import SearchProvidersResults from './SearchProvidersResults'
export default SearchProvidersResults
